import React from 'react';
import HojaCaratula from './base/HojaCaratula';

// Etiquetas EXACTAS de la plantilla (templates/caratula/caratula_puam.docx): el modal es una
// vista previa, así que lo que se lee acá tiene que coincidir renglón por renglón con el
// papel. `guardable` marca los que además de imprimirse vuelven al cliente/trámite (ver
// CaratulaPuamDocumentoService.persistirDatosGuardables).
const CAMPOS = {
    ingreso: { label: 'INGRESO', tipo: 'fecha' },
    liq: {
        label: 'LIQ', tipo: 'texto',
        nota: 'Viene de la fecha de liquidar del trámite. Lo que edites acá va solo al documento: para cambiarla de verdad, editala en la ficha del trámite (al lado de la carpeta).',
    },
    pacto: { label: 'PACTO', tipo: 'sino' },
    cuota: { label: 'CUOTA', tipo: 'texto', guardable: true },

    claveFiscal: { label: 'CLAVE FISCAL', tipo: 'clave', guardable: true },
    claveCvss: { label: 'CLAVE CVSS', tipo: 'clave', guardable: true },
    referencia: { label: 'REFERENCIA', tipo: 'texto' },

    apellidoNombre: { label: 'APELLIDO/NOMBRE', tipo: 'texto' },
    dniCuit: { label: 'DNI/CUIT', tipo: 'texto' },
    fechaNacimiento: { label: 'FECHA DE NACIMIENTO', tipo: 'fecha', guardable: true, noFutura: true },
    nacionalidad: { label: 'NACIONALIDAD', tipo: 'texto', guardable: true },
    domicilio: {
        label: 'DOMICILIO', tipo: 'domicilio', estructurado: 'domicilioDniDatos', guardable: true,
        nota: 'Se guarda en el domicilio DNI del cliente (el barrio que ya tenga se conserva). Vacío no borra nada.',
    },
    telefono: {
        label: 'Nº TELEFONICO', tipo: 'texto',
        nota: 'Trae el teléfono propio y los contactos adicionales del cliente. Se editan desde la ficha del cliente.',
    },
    mail: { label: 'MAIL', tipo: 'email', guardable: true },
    estadoCivil: { label: 'ESTADO CIVIL', tipo: 'estadoCivil', guardable: true },

    // A diferencia de las otras carátulas, acá estos dos NO son meses de aportes: son las
    // incompatibilidades con la PUAM que el trámite ya guarda, y el modal las edita.
    relacionDependencia: {
        label: 'RELACION DE DEPENDENCIA', tipo: 'sino', guardable: true,
        nota: 'Incompatibilidad: si sigue trabajando en relación de dependencia. Se guarda en el trámite.',
    },
    autonomoMonotributo: {
        label: 'AUTONOMO O MONOTRIBUTO', tipo: 'sino', guardable: true,
        nota: 'Incompatibilidad: monotributo activo. Se guarda en el trámite; ponerlo en NO destilda también "monotributo dado de baja".',
    },

    observaciones: { label: 'OBSERVACIONES', tipo: 'multilinea', guardable: true },
    iniciar: {
        label: 'INICIAR', tipo: 'texto', guardable: true,
        nota: 'Se prellena con la fecha de inicio estimada del trámite si está vacío. Admite texto libre ("a coordinar"). Guardarlo no modifica esa fecha.',
    },
};

// Una sola plantilla, así que la distribución es fija (a diferencia de Jubilación y Reajuste,
// que eligen entre dos LAYOUTS). Un array de 1 key = renglón simple; de 2 = dos columnas.
const CAJAS_CABECERA = [['ingreso', 'liq'], ['pacto', 'cuota']];
const FILA_CLAVES = ['claveFiscal', 'claveCvss'];
const FILA_REFERENCIA = ['referencia'];
const FILAS_CUERPO = [
    ['apellidoNombre'],
    ['dniCuit'],
    ['fechaNacimiento'],
    ['nacionalidad'],
    ['domicilio'],
    ['telefono'],
    ['mail'],
    ['estadoCivil'],
    ['relacionDependencia'],
    ['autonomoMonotributo'],
    ['observaciones'],
    ['iniciar'],
];

// Cómo se dibuja la hoja: título del documento, las cajitas de arriba, los renglones que
// van fuera del recuadro y el bloque principal. HojaCaratula pone el resto (modal, aviso,
// hoja A4 y botones), que es igual en las ocho carátulas.
const LAYOUT = {
    tituloDoc: 'DATOS PERSONALES',
    leyendaDoc: 'PUAM',
    cabecera: CAJAS_CABECERA,
    filasPrevias: [FILA_CLAVES, FILA_REFERENCIA],
    cuerpo: FILAS_CUERPO,
};

/**
 * Modal de la Carátula de PUAM. Muestra los renglones prellenados (lo que ya está en el
 * cliente/trámite, o calculado desde los aportes) y en blanco lo que falta, para completar
 * antes de generar. Al confirmar, "Guardar y generar" persiste los renglones guardables y
 * emite el .docx con el DTO tal cual quedó en el formulario (WYSIWYG).
 */
export default function ModalCaratulaPuam(props) {
    return (
        <HojaCaratula
            {...props}
            titulo="Generar Carátula de PUAM"
            nombreDocumento="la Carátula de PUAM"
            campos={CAMPOS}
            layout={LAYOUT}
        />
    );
}
